import { dispatcher } from 'dispatcher';
import { useDispatch } from 'react-redux';
import { useEffect, useCallback } from 'react';
import { useUserSelector } from 'js/store/hooks';
import { usePrevious } from 'js/hooks/usePrevious';
import { useEffectOnce } from 'js/hooks/useEffectOnce';

import * as actions from '../store/actions';

export const useLegacyModelSync = () => {
    const user = useUserSelector();
    const dispatch = useDispatch();
    const prevUser = usePrevious(user);

    const setUserModel = useCallback((key, val) => {
        if (key == null) {
            return;
        }

        const data = typeof key === 'object'
            ? key
            : { [key]: val };

        dispatch(actions.setLegacyUserDataAction(data));
    }, [dispatch]);

    // sync bb -> react user changes
    useEffect(() => {
        dispatcher.on('user:set', setUserModel);

        return () => {
            dispatcher.off('user:set', setUserModel);
        };
    }, [setUserModel]);

    // initial react -> bb user sync
    useEffectOnce(() => {
        dispatcher.dispatch('user:sync:change', user);
    }, [user]);

    // sync react -> bb user changes
    useEffect(() => {
        const currentKeys = Object.keys(user);

        const changedEntries = Object.entries(user)
            .filter(([key, value]) => prevUser?.[key] !== value);
        const deletedEntries = Object.keys(prevUser || {})
            .filter(key => !currentKeys.includes(key))
            .map(key => [key, undefined]);

        if (changedEntries.length) {
            dispatcher.dispatch('user:sync:change', Object.fromEntries(changedEntries));
        }

        if (deletedEntries.length) {
            dispatcher.dispatch('user:sync:delete', Object.fromEntries(deletedEntries));
        }
    }, [user, prevUser]);
};
